import { render } from "./Factory.vue?vue&type=template&id=59c592be&scoped=true"
import script from "./Factory.vue?vue&type=script&lang=js"
export * from "./Factory.vue?vue&type=script&lang=js"

import "./Factory.vue?vue&type=style&index=0&id=59c592be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c592be"]])

export default __exports__